import AbstractThirdParty from './AbstractThirdParty';

class TikTokService extends AbstractThirdParty {
  globalName = 'ttq';

  trackMethod = 'track';
}

export default new TikTokService();
